module.exports = __webpack_public_path__ + "pn.8b1dcfe61ffd764ef806.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/pn.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/pn.svg
// module chunks = styles